export const userRoles = Object.freeze({
    clubOwner: "ROLE_ADMIN",
    coach: "ROLE_COACH",
    user: "ROLE_USER",
    clubStaff: "ROLE_STAFF",
    guest: "ROLE_GUEST",
})

export const isClubOwner = (userInfo) => userInfo?.authorities?.some(item=>item.roleName===userRoles.clubOwner);
export const isClubStaff = (userInfo) => userInfo?.authorities?.some(item => item.roleName ===userRoles.clubStaff);
export const isCoach = (userInfo) => userInfo?.authorities?.some(item => item.roleName ===userRoles.coach);
export const isUser = (userInfo) => userInfo?.authorities?.some(item => item.roleName ===userRoles.user);
export const isGuest = (userInfo) => userInfo?.authorities?.some(item => item.roleName ===userRoles.guest);

export const ROLE_API_NAMES = Object.freeze({
    PLAYER: "USER",
    STAFF: "STAFF",
    COACH: "COACH",
});

const ROLE_LABELS = Object.freeze({
    USER: "Player",
    PLAYER: "Player",
    STAFF: "Staff",
    COACH: "Coach",
    ADMIN: "Admin",
    GUEST: "Guest",
});

const normalizeRoleKey = (role) =>
    String(role ?? "").replace(/^ROLE_/i, "").trim().toUpperCase();

export const formatRoleLabel = (role) => {
    const key = normalizeRoleKey(role);
    return ROLE_LABELS[key] || (key ? key.charAt(0) + key.slice(1).toLowerCase() : "");
};

export const formatRoleLabels = (roles = []) =>
    (Array.isArray(roles) ? roles : [roles]).map(formatRoleLabel).filter(Boolean).join(", ");

export const toRoleApiName = (role) => {
    const key = normalizeRoleKey(role);
    if (key === "PLAYER" || key === "USER") return ROLE_API_NAMES.PLAYER;
    if (key === "STAFF") return ROLE_API_NAMES.STAFF;
    if (key === "COACH") return ROLE_API_NAMES.COACH;
    return key;
};

export const hasAccessManagementRole = (roles = []) =>
    (Array.isArray(roles) ? roles : [roles]).some((role) => {
        const key = toRoleApiName(role);
        return key === ROLE_API_NAMES.STAFF || key === ROLE_API_NAMES.COACH;
    });

export const canChangeClubRole = (roles = []) => {
    const keys = (Array.isArray(roles) ? roles : [roles]).map((role) => normalizeRoleKey(role));
    return keys.length > 0 && !keys.includes("ADMIN");
};

export const primaryClubRole = (roles = [], fallback) => {
    const keys = (Array.isArray(roles) ? roles : [roles]).map(toRoleApiName).filter(Boolean);
    if (keys.includes(ROLE_API_NAMES.STAFF)) return ROLE_API_NAMES.STAFF;
    if (keys.includes(ROLE_API_NAMES.COACH)) return ROLE_API_NAMES.COACH;
    if (keys.includes(ROLE_API_NAMES.PLAYER)) return ROLE_API_NAMES.PLAYER;
    return toRoleApiName(fallback) || ROLE_API_NAMES.PLAYER;
};

export const toManagePlayerRow = (member) => ({
    playerId: member.userId || member.playerId,
    playerName: member.playerName || `${member.userFirstName || ""} ${member.userLastName || ""}`.trim(),
    playerStatus: member.playerStatus || member.userStatus,
    roleName: primaryClubRole(member.roles, member.roleName || member.userRole),
    roles: member.roles,
    email: member.email || member.userEmail,
    phone: member.phone || member.userPhone || "",
    profileImage: member.profileImage || member.userProfileImage,
    subStatus: member.subStatus,
    subId: member.subId,
    planName: member.planName,
    totalPlayer: member.totalPlayer ?? member.totalUser,
});



//// BOTTOM NO LONGER REQUIRED

const friendlyRoleNames = {
    [userRoles.clubOwner]: "ADMIN",
    [userRoles.clubStaff]: "STAFF",
    [userRoles.coach]: "COACH",
    [userRoles.user]: "PLAYER"
  };

  

  const rolePriority = [
    userRoles.user,       // ROLE_USER
    userRoles.coach,      // ROLE_COACH
    userRoles.clubStaff,  // ROLE_STAFF
    userRoles.clubOwner,  // ROLE_ADMIN
  ];
  
  export const getHighestRole = (userInfo) => {

   // console.log("userInfo", userInfo);
    if (!userInfo?.authorities?.length) return null;
  
    const assignedRoles = userInfo.authorities
      .map(a => a?.roleName?.trim())
      .filter(Boolean);


     // console.log("assignedRoles", assignedRoles);
  
    for (let i = rolePriority.length - 1; i >= 0; i--) {
      if (assignedRoles.includes(rolePriority[i])) {
        return friendlyRoleNames[rolePriority[i]] || null; // return friendly name
      }
    }
  
    return null;
  };
  
  
  
  